import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const PAGES = [
  { key: "home", label: "Home", desc: "Hero, challenges, testimonials, channels" },
  { key: "about", label: "About Us", desc: "Company story, mission, team" },
  { key: "services", label: "Services", desc: "Service offerings and capabilities" },
  { key: "demos", label: "Demos", desc: "Demo showcase and CTAs" },
  { key: "contact", label: "Contact Us", desc: "Contact form and information" },
  { key: "terms", label: "Terms & Conditions", desc: "Legal terms of service (ES + EN)" },
  { key: "privacy", label: "Privacy Policy", desc: "Data protection policy (ES + EN)" },
  { key: "cookies", label: "Cookie Banner", desc: "Consent banner labels & categories (ES + EN)" },
  { key: "seo", label: "SEO Metadata", desc: "Page titles, descriptions, keywords & OG tags (ES + EN)" },
  { key: "svc-sales", label: "Service · Sales", desc: "Sales conversational service detail page" },
  { key: "svc-logistics", label: "Service · Logistics", desc: "Logistics & tracking detail page" },
  { key: "svc-data-analysis", label: "Service · Data Analysis", desc: "Analytics & dashboards detail page" },
  { key: "svc-support", label: "Service · Support", desc: "Customer support detail page" },
  { key: "svc-credit", label: "Service · Credit", desc: "Credit origination detail page" },
];

export default function AdminDashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="admin-shell">
      <div className="admin-topbar">
        <h1><span className="dot" /> Dosmass CMS</h1>
        <div className="right">
          <a
            href="/"
            target="_blank"
            rel="noreferrer"
            className="btn secondary"
            data-testid="view-site"
          >
            View site →
          </a>
          <span style={{ color: "#a0a0a8", fontSize: 13 }} data-testid="user-email">
            {user?.email}
          </span>
          <button
            className="btn danger"
            onClick={async () => { await logout(); navigate("/admin/login"); }}
            data-testid="logout-btn"
          >
            Logout
          </button>
        </div>
      </div>

      <div className="admin-content">
        <h2 style={{ marginTop: 0 }}>Pages</h2>
        <p style={{ color: "#a0a0a8" }}>
          Select a page to edit its content in both languages (Spanish &amp; English).
        </p>

        <div className="cards-grid">
          {PAGES.map((p) => (
            <Link
              to={`/admin/editor/${p.key}`}
              key={p.key}
              className="page-card"
              data-testid={`page-card-${p.key}`}
            >
              <h3>{p.label}</h3>
              <p>{p.desc}</p>
              <p style={{ color: "#a855f7", fontWeight: 600, marginTop: 8 }}>Edit →</p>
            </Link>
          ))}
          <Link
            to="/admin/submissions"
            className="page-card"
            data-testid="page-card-submissions"
            style={{ borderStyle: "dashed", borderColor: "#4c1d95" }}
          >
            <h3>📬 Submissions</h3>
            <p>Contact form submissions — inbox with status, reply, archive</p>
            <p style={{ color: "#a855f7", fontWeight: 600, marginTop: 8 }}>Open inbox →</p>
          </Link>
          <Link
            to="/admin/settings"
            className="page-card"
            data-testid="page-card-settings"
            style={{ borderStyle: "dashed" }}
          >
            <h3>Settings</h3>
            <p>Analytics (PostHog + GA4), integrations, site-wide config</p>
            <p style={{ color: "#a855f7", fontWeight: 600, marginTop: 8 }}>Configure →</p>
          </Link>
        </div>
      </div>
    </div>
  );
}
